import { createRoute, redirect } from '@tanstack/react-router';
import { ensureSession } from '@/lib/api/auth';
import { meQuery } from '@/lib/me';
import { applyMe } from './bootstrap';
import { rootRoute } from './rootRoute';

/**
 * The signed-in app: a pathless layout route that needs a session and `/api/me`. Its
 * component (the shell) is attached in router.tsx, so modules can import this route to hang
 * their pages under it without an import cycle.
 */
export const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'app',
  beforeLoad: async ({ context, location }) => {
    if (!(await ensureSession())) {
      throw redirect({ to: '/login', search: { next: location.href } });
    }
    const me = await context.queryClient.ensureQueryData(meQuery);
    applyMe(me);
  },
});
